import { render, staticRenderFns } from "./HistoricalScores.vue?vue&type=template&id=57501da2&scoped=true"
import script from "./HistoricalScores.vue?vue&type=script&lang=js"
export * from "./HistoricalScores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57501da2",
  null
  
)

export default component.exports